import { useContext } from 'react';
import { Grid, Typography } from '@mui/material';
import { orderContext } from '../OrderContext';
import { DetailsPageHeader } from 'components';
import { CustomerType } from 'helpers/enums';


let BillingAddress = () => {
    let service = useContext(orderContext);

    return (
        <DetailsPageHeader sectionName='Billing address'>
            {service.order.billingAddress &&
                <Grid container>
                    <Grid item xs={3}>
                        <Typography>Customer type</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography>
                            {service.order.billingAddress.customerType}
                            &nbsp;{service.order.billingAddress.isB2B === true ? 'B2B' : 'B2C'}
                        </Typography>
                    </Grid>
                    {service.order.billingAddress.customerType === CustomerType.Company &&
                        <>
                            <Grid item xs={3}>
                                <Typography>Company Name</Typography>
                            </Grid>
                            <Grid item xs={9}>
                                <Typography>
                                    {service.order.billingAddress.companyName}
                                </Typography>
                            </Grid>
                        </>
                    }
                    <Grid item xs={3}>
                        <Typography>Email</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography>{service.order.billingAddress.email}</Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography>Phone number</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography>{service.order.billingAddress.phoneNumber}</Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography>Address line 1</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography>{service.order.billingAddress.addressLine1}</Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography>Address line 2</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography>{service.order.billingAddress.addressLine2}</Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography>City</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography>{service.order.billingAddress.city}</Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography>State</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography>{service.order.billingAddress.stateCode}&nbsp;&middot;&nbsp;{service.order.billingAddress.state}</Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography>Postal code</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography>{service.order.billingAddress.postalCode}</Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography>Country code</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography>{service.order.billingAddress.countryCode}</Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography>ERP</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography>
                            {service.order.billingAddress.erpCustomerCode}
                            {service.order.billingAddress.erpAddressCode && ` - Address code: ${service.order.billingAddress.erpAddressCode}`}
                        </Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography>Vat number</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography>{service.order.billingAddress.vatNumber}</Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography>Fiscal code</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography>{service.order.billingAddress.fiscalCode}</Typography>
                    </Grid>
                    {service.order.billingAddress.countryCode === "IT" &&
                        <>
                            <Grid item xs={3}>
                                <Typography>Invoice code</Typography>
                            </Grid>
                            <Grid item xs={9}>
                                <Typography>{service.order.billingAddress.eInvoiceCode}</Typography>
                            </Grid>
                            <Grid item xs={3}>
                                <Typography>Invoice PEC</Typography>
                            </Grid>
                            <Grid item xs={9}>
                                <Typography>{service.order.billingAddress.eInvoicePec}</Typography>
                            </Grid>
                        </>
                    }
                </Grid>
            }
        </DetailsPageHeader>
    );
}

export default BillingAddress;